/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ZonHub
 * Project management for Solar
 * OpenAPI spec version: 1.0.0
 */
import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query"
import { useMutation, useQuery } from "@tanstack/react-query"

import type {
	ApiSchemaRetrieve200Four,
	ApiSchemaRetrieve200One,
	ApiSchemaRetrieve200Three,
	ApiSchemaRetrieve200Two,
	ApiSchemaRetrieveParams,
	ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	ApiV1InvestmentSessionRetrieve200,
	ApiV1InvestorIbanPartialUpdate200,
	ApiV1InvestorIbanPartialUpdate400,
	ApiV1PaymentOwnerVerificationRetrieveParams,
	ApiV1PaymentSupplierVerificationRetrieveParams,
	ApiV1ProfilePhonePartialUpdate200,
	ApiV1ProfilePhonePartialUpdate400,
	EndexPrice,
	EndexProgressGlobal,
	EndexProgressProject,
	EndexTariff,
	FooterResponse,
	LivePerformance,
	OwnerVerification,
	OwnerVerificationResponse,
	PaginatedNavigationItemTypeList,
	PatchedIban,
	PatchedUserPhone,
	ProductionFactor,
	SupplierVerification,
	SupplierVerificationResponse,
	UserProfile,
	VerificationPayment,
} from "../@types"

import { apiWithTokenAuth } from "../../api"

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
	(<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B

type WritableKeys<T> = {
	[P in keyof T]-?: IfEquals<
		{ [Q in P]: T[P] },
		{ -readonly [Q in P]: T[P] },
		P
	>
}[keyof T]

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
	k: infer I,
) => void
	? I
	: never
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never

type Writable<T> = Pick<T, WritableKeys<T>>
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
	? {
			[P in keyof Writable<T>]: T[P] extends object
				? NonReadonly<NonNullable<T[P]>>
				: T[P]
		}
	: DistributeReadOnlyOverUnions<T>

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K }
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		})
	}
	return result
}

export const getApiCmsFooterRetrieveUrl = () => {
	return `/api/cms/footer/`
}

export const apiCmsFooterRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<FooterResponse> => {
	return apiWithTokenAuth<FooterResponse>(getApiCmsFooterRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiCmsFooterRetrieveQueryKey = () => {
	return [`/api/cms/footer/`] as const
}

export const getApiCmsFooterRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiCmsFooterRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
	> = ({ signal }) => apiCmsFooterRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
>
export type ApiCmsFooterRetrieveQueryError = unknown

export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiCmsFooterRetrieve2Url = (id: number) => {
	return `/api/cms/footer/${id}/`
}

export const apiCmsFooterRetrieve2 = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiCmsFooterRetrieve2Url(id), {
		...options,
		method: "GET",
	})
}

export const getApiCmsFooterRetrieve2QueryKey = (id: number) => {
	return [`/api/cms/footer/${id}/`] as const
}

export const getApiCmsFooterRetrieve2QueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsFooterRetrieve2QueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
	> = ({ signal }) => apiCmsFooterRetrieve2(id, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterRetrieve2QueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
>
export type ApiCmsFooterRetrieve2QueryError = unknown

export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterRetrieve2<
	TData = Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterRetrieve2>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterRetrieve2QueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiCmsFooterFindRetrieveUrl = () => {
	return `/api/cms/footer/find/`
}

export const apiCmsFooterFindRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiCmsFooterFindRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiCmsFooterFindRetrieveQueryKey = () => {
	return [`/api/cms/footer/find/`] as const
}

export const getApiCmsFooterFindRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsFooterFindRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
	> = ({ signal }) => apiCmsFooterFindRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsFooterFindRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
>
export type ApiCmsFooterFindRetrieveQueryError = unknown

export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsFooterFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsFooterFindRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsFooterFindRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiCmsNavigationListUrl = () => {
	return `/api/cms/navigation/`
}

export const apiCmsNavigationList = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<PaginatedNavigationItemTypeList> => {
	return apiWithTokenAuth<PaginatedNavigationItemTypeList>(
		getApiCmsNavigationListUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiCmsNavigationListQueryKey = () => {
	return [`/api/cms/navigation/`] as const
}

export const getApiCmsNavigationListQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationList>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiCmsNavigationListQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationList>>
	> = ({ signal }) => apiCmsNavigationList({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationList>>
>
export type ApiCmsNavigationListQueryError = unknown

export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationList>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationList>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationList>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationList>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationList<
	TData = Awaited<ReturnType<typeof apiCmsNavigationList>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationList>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationListQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiCmsNavigationRetrieveUrl = (id: number) => {
	return `/api/cms/navigation/${id}/`
}

export const apiCmsNavigationRetrieve = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiCmsNavigationRetrieveUrl(id), {
		...options,
		method: "GET",
	})
}

export const getApiCmsNavigationRetrieveQueryKey = (id: number) => {
	return [`/api/cms/navigation/${id}/`] as const
}

export const getApiCmsNavigationRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsNavigationRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
	> = ({ signal }) =>
		apiCmsNavigationRetrieve(id, { signal, ...requestOptions })

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
>
export type ApiCmsNavigationRetrieveQueryError = unknown

export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiCmsNavigationFindRetrieveUrl = () => {
	return `/api/cms/navigation/find/`
}

export const apiCmsNavigationFindRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiCmsNavigationFindRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiCmsNavigationFindRetrieveQueryKey = () => {
	return [`/api/cms/navigation/find/`] as const
}

export const getApiCmsNavigationFindRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiCmsNavigationFindRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
	> = ({ signal }) =>
		apiCmsNavigationFindRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCmsNavigationFindRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
>
export type ApiCmsNavigationFindRetrieveQueryError = unknown

export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiCmsNavigationFindRetrieve<
	TData = Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiCmsNavigationFindRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiCmsNavigationFindRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiSchemaRetrieveUrl = (params?: ApiSchemaRetrieveParams) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null ? "null" : String(value),
			)
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/api/schema/?${stringifiedParams}`
		: `/api/schema/`
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = async (
	params?: ApiSchemaRetrieveParams,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<
	| ApiSchemaRetrieve200One
	| ApiSchemaRetrieve200Two
	| ApiSchemaRetrieve200Three
	| ApiSchemaRetrieve200Four
> => {
	return apiWithTokenAuth<
		| ApiSchemaRetrieve200One
		| ApiSchemaRetrieve200Two
		| ApiSchemaRetrieve200Three
		| ApiSchemaRetrieve200Four
	>(getApiSchemaRetrieveUrl(params), {
		...options,
		method: "GET",
	})
}

export const getApiSchemaRetrieveQueryKey = (
	params?: ApiSchemaRetrieveParams,
) => {
	return [`/api/schema/`, ...(params ? [params] : [])] as const
}

export const getApiSchemaRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiSchemaRetrieveQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiSchemaRetrieve>>
	> = ({ signal }) => apiSchemaRetrieve(params, { signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiSchemaRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiSchemaRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiSchemaRetrieve>>
>
export type ApiSchemaRetrieveQueryError = unknown

export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params: undefined | ApiSchemaRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiSchemaRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiSchemaRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiSchemaRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiSchemaRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiSchemaRetrieve<
	TData = Awaited<ReturnType<typeof apiSchemaRetrieve>>,
	TError = unknown,
>(
	params?: ApiSchemaRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiSchemaRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiSchemaRetrieveQueryOptions(params, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ClientRetrieveUrl = () => {
	return `/api/v1/client/`
}

/**
 * API view with client details: their sensors, panels and home type.
 *
 * Note that this includes sensor tokens, so this is sensitive information.
 */
export const apiV1ClientRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiV1ClientRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiV1ClientRetrieveQueryKey = () => {
	return [`/api/v1/client/`] as const
}

export const getApiV1ClientRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiV1ClientRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ClientRetrieve>>
	> = ({ signal }) => apiV1ClientRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ClientRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ClientRetrieve>>
>
export type ApiV1ClientRetrieveQueryError = unknown

export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ClientRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ClientRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ClientRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ClientRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ClientRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonEndexProgressGlobalRetrieveUrl = (
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null ? "null" : String(value),
			)
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/api/v1/comparison/endex-progress-global/?${stringifiedParams}`
		: `/api/v1/comparison/endex-progress-global/`
}

/**
 * API view that shows all endex tariffs for a certain date range
 */
export const apiV1ComparisonEndexProgressGlobalRetrieve = async (
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<EndexProgressGlobal> => {
	return apiWithTokenAuth<EndexProgressGlobal>(
		getApiV1ComparisonEndexProgressGlobalRetrieveUrl(params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonEndexProgressGlobalRetrieveQueryKey = (
	params?: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
) => {
	return [
		`/api/v1/comparison/endex-progress-global/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1ComparisonEndexProgressGlobalRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonEndexProgressGlobalRetrieveQueryKey(params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>
	> = ({ signal }) =>
		apiV1ComparisonEndexProgressGlobalRetrieve(params, {
			signal,
			...requestOptions,
		})

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonEndexProgressGlobalRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>>
>
export type ApiV1ComparisonEndexProgressGlobalRetrieveQueryError = unknown

export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonEndexProgressGlobalRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonEndexProgressGlobalRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonEndexProgressGlobalRetrieve>
	>,
	TError = unknown,
>(
	params: ApiV1ComparisonEndexProgressGlobalRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonEndexProgressGlobalRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonEndexProgressGlobalRetrieveQueryOptions(
			params,
			options,
		)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonProjectEndexPriceRetrieveUrl = (id: number) => {
	return `/api/v1/comparison/project/${id}/endex-price/`
}

/**
 * An API view for returning current Endex price
 */
export const apiV1ComparisonProjectEndexPriceRetrieve = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<EndexPrice> => {
	return apiWithTokenAuth<EndexPrice>(
		getApiV1ComparisonProjectEndexPriceRetrieveUrl(id),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonProjectEndexPriceRetrieveQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-price/`] as const
}

export const getApiV1ComparisonProjectEndexPriceRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexPriceRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>
	> = ({ signal }) =>
		apiV1ComparisonProjectEndexPriceRetrieve(id, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexPriceRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>>
>
export type ApiV1ComparisonProjectEndexPriceRetrieveQueryError = unknown

export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexPriceRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexPriceRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexPriceRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectEndexPriceRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonProjectEndexProgressRetrieveUrl = (
	id: number,
) => {
	return `/api/v1/comparison/project/${id}/endex-progress/`
}

/**
 * API view that shows all endex tariffs for a specific project's interestperiods
 */
export const apiV1ComparisonProjectEndexProgressRetrieve = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<EndexProgressProject> => {
	return apiWithTokenAuth<EndexProgressProject>(
		getApiV1ComparisonProjectEndexProgressRetrieveUrl(id),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonProjectEndexProgressRetrieveQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-progress/`] as const
}

export const getApiV1ComparisonProjectEndexProgressRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexProgressRetrieveQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>
	> = ({ signal }) =>
		apiV1ComparisonProjectEndexProgressRetrieve(id, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexProgressRetrieveQueryResult =
	NonNullable<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>>
	>
export type ApiV1ComparisonProjectEndexProgressRetrieveQueryError = unknown

export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexProgressRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexProgressRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectEndexProgressRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectEndexProgressRetrieve
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectEndexProgressRetrieveQueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonProjectEndexTariffsListUrl = (id: number) => {
	return `/api/v1/comparison/project/${id}/endex-tariffs/`
}

/**
 * API view that shows all endex tariffs for a specific project's interestperiods
 */
export const apiV1ComparisonProjectEndexTariffsList = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<EndexTariff[]> => {
	return apiWithTokenAuth<EndexTariff[]>(
		getApiV1ComparisonProjectEndexTariffsListUrl(id),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonProjectEndexTariffsListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/endex-tariffs/`] as const
}

export const getApiV1ComparisonProjectEndexTariffsListQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectEndexTariffsListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>
	> = ({ signal }) =>
		apiV1ComparisonProjectEndexTariffsList(id, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectEndexTariffsListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>
>
export type ApiV1ComparisonProjectEndexTariffsListQueryError = unknown

export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectEndexTariffsList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectEndexTariffsList<
	TData = Awaited<ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectEndexTariffsList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ComparisonProjectEndexTariffsListQueryOptions(
		id,
		options,
	)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonProjectLivePerformanceListUrl = (id: number) => {
	return `/api/v1/comparison/project/${id}/live-performance/`
}

/**
 * API view for getting data for live performance graph.
 */
export const apiV1ComparisonProjectLivePerformanceList = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<LivePerformance[]> => {
	return apiWithTokenAuth<LivePerformance[]>(
		getApiV1ComparisonProjectLivePerformanceListUrl(id),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonProjectLivePerformanceListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/live-performance/`] as const
}

export const getApiV1ComparisonProjectLivePerformanceListQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectLivePerformanceListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>
	> = ({ signal }) =>
		apiV1ComparisonProjectLivePerformanceList(id, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectLivePerformanceListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>>
>
export type ApiV1ComparisonProjectLivePerformanceListQueryError = unknown

export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectLivePerformanceList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectLivePerformanceList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1ComparisonProjectLivePerformanceList>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectLivePerformanceListQueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ComparisonProjectProductionFactorListUrl = (
	id: number,
) => {
	return `/api/v1/comparison/project/${id}/production-factor/`
}

/**
 * API view for getting data for production factor table.
 */
export const apiV1ComparisonProjectProductionFactorList = async (
	id: number,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<ProductionFactor[]> => {
	return apiWithTokenAuth<ProductionFactor[]>(
		getApiV1ComparisonProjectProductionFactorListUrl(id),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1ComparisonProjectProductionFactorListQueryKey = (
	id: number,
) => {
	return [`/api/v1/comparison/project/${id}/production-factor/`] as const
}

export const getApiV1ComparisonProjectProductionFactorListQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1ComparisonProjectProductionFactorListQueryKey(id)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>
	> = ({ signal }) =>
		apiV1ComparisonProjectProductionFactorList(id, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ComparisonProjectProductionFactorListQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ComparisonProjectProductionFactorList>>
>
export type ApiV1ComparisonProjectProductionFactorListQueryError = unknown

export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1ComparisonProjectProductionFactorList
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ComparisonProjectProductionFactorList<
	TData = Awaited<
		ReturnType<typeof apiV1ComparisonProjectProductionFactorList>
	>,
	TError = unknown,
>(
	id: number,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<
						typeof apiV1ComparisonProjectProductionFactorList
					>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1ComparisonProjectProductionFactorListQueryOptions(id, options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1InvestmentSessionRetrieveUrl = () => {
	return `/api/v1/investment/session/`
}

/**
 * API endpoint to fetch details about the investment thats stored in the session.
 * Requires authentication.
 */
export const apiV1InvestmentSessionRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<ApiV1InvestmentSessionRetrieve200> => {
	return apiWithTokenAuth<ApiV1InvestmentSessionRetrieve200>(
		getApiV1InvestmentSessionRetrieveUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1InvestmentSessionRetrieveQueryKey = () => {
	return [`/api/v1/investment/session/`] as const
}

export const getApiV1InvestmentSessionRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiV1InvestmentSessionRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
	> = ({ signal }) =>
		apiV1InvestmentSessionRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1InvestmentSessionRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
>
export type ApiV1InvestmentSessionRetrieveQueryError = unknown

export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1InvestmentSessionRetrieve<
	TData = Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1InvestmentSessionRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1InvestmentSessionRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1InvestorIbanPartialUpdateUrl = () => {
	return `/api/v1/investor/iban/`
}

/**
 * Update IBAN for the authenticated user.
 */
export const apiV1InvestorIbanPartialUpdate = async (
	patchedIban?: NonReadonly<PatchedIban>,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<ApiV1InvestorIbanPartialUpdate200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {}
		if (h instanceof Headers) return Object.fromEntries(h.entries())
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			)
		}
		const headers: Record<string, string | readonly string[]> = {}
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value
		}
		return headers
	}
	return apiWithTokenAuth<ApiV1InvestorIbanPartialUpdate200>(
		getApiV1InvestorIbanPartialUpdateUrl(),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(patchedIban),
		},
	)
}

export const getApiV1InvestorIbanPartialUpdateMutationKey = () =>
	["apiV1InvestorIbanPartialUpdate"] as const

export const getApiV1InvestorIbanPartialUpdateMutationOptions = <
	TError = ApiV1InvestorIbanPartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
		TError,
		ApiV1InvestorIbanPartialUpdateMutationVariables,
		TContext
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
	TError,
	ApiV1InvestorIbanPartialUpdateMutationVariables,
	TContext
> => {
	const mutationKey = getApiV1InvestorIbanPartialUpdateMutationKey()
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
		ApiV1InvestorIbanPartialUpdateMutationVariables
	> = (props) => {
		const { data } = props ?? {}

		return apiV1InvestorIbanPartialUpdate(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1InvestorIbanPartialUpdateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>
>
export type ApiV1InvestorIbanPartialUpdateMutationBody =
	| NonReadonly<PatchedIban>
	| undefined
export type ApiV1InvestorIbanPartialUpdateMutationError =
	ApiV1InvestorIbanPartialUpdate400
export type ApiV1InvestorIbanPartialUpdateMutationVariables = {
	data?: NonReadonly<PatchedIban>
}

export const useApiV1InvestorIbanPartialUpdate = <
	TError = ApiV1InvestorIbanPartialUpdate400,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
			TError,
			ApiV1InvestorIbanPartialUpdateMutationVariables,
			TContext
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof apiV1InvestorIbanPartialUpdate>>,
	TError,
	ApiV1InvestorIbanPartialUpdateMutationVariables,
	TContext
> => {
	return useMutation(
		getApiV1InvestorIbanPartialUpdateMutationOptions(options),
		queryClient,
	)
}
export const getApiV1MeasurementKacoLastTimestampRetrieveUrl = () => {
	return `/api/v1/measurement/kaco/last_timestamp/`
}

/**
 * API view for the timestamp of the last KACO measurement in the DB.
 *
 * Used for automatic monitoring of insertion progress.
 */
export const apiV1MeasurementKacoLastTimestampRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(
		getApiV1MeasurementKacoLastTimestampRetrieveUrl(),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1MeasurementKacoLastTimestampRetrieveQueryKey = () => {
	return [`/api/v1/measurement/kaco/last_timestamp/`] as const
}

export const getApiV1MeasurementKacoLastTimestampRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<
				ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
			>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1MeasurementKacoLastTimestampRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>
	> = ({ signal }) =>
		apiV1MeasurementKacoLastTimestampRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1MeasurementKacoLastTimestampRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>>
>
export type ApiV1MeasurementKacoLastTimestampRetrieveQueryError = unknown

export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1MeasurementKacoLastTimestampRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1MeasurementKacoLastTimestampRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1MeasurementKacoLastTimestampRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1MeasurementKacoLastTimestampRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1MeasurementKacoLastTimestampRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
	>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1MeasurementKacoLastTimestampRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1MeasurementKacoLastTimestampRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1PaymentOwnerVerificationRetrieveUrl = (
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null ? "null" : String(value),
			)
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/api/v1/payment/${id}/owner-verification/?${stringifiedParams}`
		: `/api/v1/payment/${id}/owner-verification/`
}

/**
 * A method to get all clients and their related data for ProjectOwner confirmation
 */
export const apiV1PaymentOwnerVerificationRetrieve = async (
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<VerificationPayment> => {
	return apiWithTokenAuth<VerificationPayment>(
		getApiV1PaymentOwnerVerificationRetrieveUrl(id, params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1PaymentOwnerVerificationRetrieveQueryKey = (
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
) => {
	return [
		`/api/v1/payment/${id}/owner-verification/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1PaymentOwnerVerificationRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1PaymentOwnerVerificationRetrieveQueryKey(id, params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>
	> = ({ signal }) =>
		apiV1PaymentOwnerVerificationRetrieve(id, params, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1PaymentOwnerVerificationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>
>
export type ApiV1PaymentOwnerVerificationRetrieveQueryError = unknown

export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params: undefined | ApiV1PaymentOwnerVerificationRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>,
					TError,
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>,
					TError,
					Awaited<
						ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1PaymentOwnerVerificationRetrieve<
	TData = Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentOwnerVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentOwnerVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1PaymentOwnerVerificationRetrieveQueryOptions(
		id,
		params,
		options,
	)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1PaymentOwnerVerificationCreateUrl = (id: number) => {
	return `/api/v1/payment/${id}/owner-verification/`
}

/**
 * A method to accept the payment for the ProjectOwner
 */
export const apiV1PaymentOwnerVerificationCreate = async (
	id: number,
	ownerVerification: OwnerVerification,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<OwnerVerificationResponse> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {}
		if (h instanceof Headers) return Object.fromEntries(h.entries())
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			)
		}
		const headers: Record<string, string | readonly string[]> = {}
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value
		}
		return headers
	}
	return apiWithTokenAuth<OwnerVerificationResponse>(
		getApiV1PaymentOwnerVerificationCreateUrl(id),
		{
			...options,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(ownerVerification),
		},
	)
}

export const getApiV1PaymentOwnerVerificationCreateMutationKey = () =>
	["apiV1PaymentOwnerVerificationCreate"] as const

export const getApiV1PaymentOwnerVerificationCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
		TError,
		ApiV1PaymentOwnerVerificationCreateMutationVariables,
		TContext
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
	TError,
	ApiV1PaymentOwnerVerificationCreateMutationVariables,
	TContext
> => {
	const mutationKey = getApiV1PaymentOwnerVerificationCreateMutationKey()
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
		ApiV1PaymentOwnerVerificationCreateMutationVariables
	> = (props) => {
		const { id, data } = props ?? {}

		return apiV1PaymentOwnerVerificationCreate(id, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1PaymentOwnerVerificationCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>
>
export type ApiV1PaymentOwnerVerificationCreateMutationBody = OwnerVerification
export type ApiV1PaymentOwnerVerificationCreateMutationError = unknown
export type ApiV1PaymentOwnerVerificationCreateMutationVariables = {
	id: number
	data: OwnerVerification
}

export const useApiV1PaymentOwnerVerificationCreate = <
	TError = unknown,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
			TError,
			ApiV1PaymentOwnerVerificationCreateMutationVariables,
			TContext
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof apiV1PaymentOwnerVerificationCreate>>,
	TError,
	ApiV1PaymentOwnerVerificationCreateMutationVariables,
	TContext
> => {
	return useMutation(
		getApiV1PaymentOwnerVerificationCreateMutationOptions(options),
		queryClient,
	)
}
export const getApiV1PaymentSupplierVerificationRetrieveUrl = (
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
) => {
	const normalizedParams = new URLSearchParams()

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null ? "null" : String(value),
			)
		}
	})

	const stringifiedParams = normalizedParams.toString()

	return stringifiedParams.length > 0
		? `/api/v1/payment/${id}/supplier-verification/?${stringifiedParams}`
		: `/api/v1/payment/${id}/supplier-verification/`
}

/**
 * A method to get all clients and their related data for ProjectOwner confirmation
 */
export const apiV1PaymentSupplierVerificationRetrieve = async (
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<VerificationPayment> => {
	return apiWithTokenAuth<VerificationPayment>(
		getApiV1PaymentSupplierVerificationRetrieveUrl(id, params),
		{
			...options,
			method: "GET",
		},
	)
}

export const getApiV1PaymentSupplierVerificationRetrieveQueryKey = (
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
) => {
	return [
		`/api/v1/payment/${id}/supplier-verification/`,
		...(params ? [params] : []),
	] as const
}

export const getApiV1PaymentSupplierVerificationRetrieveQueryOptions = <
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ??
		getApiV1PaymentSupplierVerificationRetrieveQueryKey(id, params)

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>
	> = ({ signal }) =>
		apiV1PaymentSupplierVerificationRetrieve(id, params, {
			signal,
			...requestOptions,
		})

	return {
		queryKey,
		queryFn,
		enabled: id !== null && id !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1PaymentSupplierVerificationRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>>
>
export type ApiV1PaymentSupplierVerificationRetrieveQueryError = unknown

export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params: undefined | ApiV1PaymentSupplierVerificationRetrieveParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>,
					TError,
					Awaited<
						ReturnType<
							typeof apiV1PaymentSupplierVerificationRetrieve
						>
					>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1PaymentSupplierVerificationRetrieve<
	TData = Awaited<
		ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
	>,
	TError = unknown,
>(
	id: number,
	params?: ApiV1PaymentSupplierVerificationRetrieveParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<
					ReturnType<typeof apiV1PaymentSupplierVerificationRetrieve>
				>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions =
		getApiV1PaymentSupplierVerificationRetrieveQueryOptions(
			id,
			params,
			options,
		)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1PaymentSupplierVerificationCreateUrl = (id: number) => {
	return `/api/v1/payment/${id}/supplier-verification/`
}

/**
 * A method to accept or reject the payment for the EnergySupplier with optionally corrected payment entries
 */
export const apiV1PaymentSupplierVerificationCreate = async (
	id: number,
	supplierVerification: SupplierVerification,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<SupplierVerificationResponse> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {}
		if (h instanceof Headers) return Object.fromEntries(h.entries())
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			)
		}
		const headers: Record<string, string | readonly string[]> = {}
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value
		}
		return headers
	}
	return apiWithTokenAuth<SupplierVerificationResponse>(
		getApiV1PaymentSupplierVerificationCreateUrl(id),
		{
			...options,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(supplierVerification),
		},
	)
}

export const getApiV1PaymentSupplierVerificationCreateMutationKey = () =>
	["apiV1PaymentSupplierVerificationCreate"] as const

export const getApiV1PaymentSupplierVerificationCreateMutationOptions = <
	TError = unknown,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
		TError,
		ApiV1PaymentSupplierVerificationCreateMutationVariables,
		TContext
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
	TError,
	ApiV1PaymentSupplierVerificationCreateMutationVariables,
	TContext
> => {
	const mutationKey = getApiV1PaymentSupplierVerificationCreateMutationKey()
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
		ApiV1PaymentSupplierVerificationCreateMutationVariables
	> = (props) => {
		const { id, data } = props ?? {}

		return apiV1PaymentSupplierVerificationCreate(id, data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1PaymentSupplierVerificationCreateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>
>
export type ApiV1PaymentSupplierVerificationCreateMutationBody =
	SupplierVerification
export type ApiV1PaymentSupplierVerificationCreateMutationError = unknown
export type ApiV1PaymentSupplierVerificationCreateMutationVariables = {
	id: number
	data: SupplierVerification
}

export const useApiV1PaymentSupplierVerificationCreate = <
	TError = unknown,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
			TError,
			ApiV1PaymentSupplierVerificationCreateMutationVariables,
			TContext
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof apiV1PaymentSupplierVerificationCreate>>,
	TError,
	ApiV1PaymentSupplierVerificationCreateMutationVariables,
	TContext
> => {
	return useMutation(
		getApiV1PaymentSupplierVerificationCreateMutationOptions(options),
		queryClient,
	)
}
export const getApiV1ProductionCounterRetrieveUrl = () => {
	return `/api/v1/production_counter/`
}

export const apiV1ProductionCounterRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<void> => {
	return apiWithTokenAuth<void>(getApiV1ProductionCounterRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiV1ProductionCounterRetrieveQueryKey = () => {
	return [`/api/v1/production_counter/`] as const
}

export const getApiV1ProductionCounterRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey =
		queryOptions?.queryKey ?? getApiV1ProductionCounterRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
	> = ({ signal }) =>
		apiV1ProductionCounterRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ProductionCounterRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
>
export type ApiV1ProductionCounterRetrieveQueryError = unknown

export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ProductionCounterRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProductionCounterRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ProductionCounterRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ProfileRetrieveUrl = () => {
	return `/api/v1/profile/`
}

/**
 * Get client profile data. To be used for populating screen C2.1.
 *
 * # Response values
 * - `client`
 *     - `name`
 *     - `email`
 *     - `phone` (optional)
 * - `latest badge` The latest user badge that has been awarded to client.
 * - `projects` Overview of projects the user has invested in
 *     - `project` Project details
 *     - `solar_parts_owned` Number of solar parts owned by client in this project
 *     - `total_nominal_value` Total nominal value of solar parts owned
 *     - `generated_power` Total generated power by solar parts owned
 *     - `power_cost_ct_kWh` Current power cost rate
 *     - `return_on_investment` Return on investment over period
 */
export const apiV1ProfileRetrieve = async (
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<UserProfile> => {
	return apiWithTokenAuth<UserProfile>(getApiV1ProfileRetrieveUrl(), {
		...options,
		method: "GET",
	})
}

export const getApiV1ProfileRetrieveQueryKey = () => {
	return [`/api/v1/profile/`] as const
}

export const getApiV1ProfileRetrieveQueryOptions = <
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(options?: {
	query?: Partial<
		UseQueryOptions<
			Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
			TError,
			TData
		>
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {}

	const queryKey = queryOptions?.queryKey ?? getApiV1ProfileRetrieveQueryKey()

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
	> = ({ signal }) => apiV1ProfileRetrieve({ signal, ...requestOptions })

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiV1ProfileRetrieveQueryResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
>
export type ApiV1ProfileRetrieveQueryError = unknown

export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
					TError,
					Awaited<ReturnType<typeof apiV1ProfileRetrieve>>
				>,
				"initialData"
			>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}
export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
}

export function useApiV1ProfileRetrieve<
	TData = Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
	TError = unknown,
>(
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof apiV1ProfileRetrieve>>,
				TError,
				TData
			>
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>
} {
	const queryOptions = getApiV1ProfileRetrieveQueryOptions(options)

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> }

	return withQueryKey(query, queryOptions.queryKey)
}

export const getApiV1ProfilePhonePartialUpdateUrl = () => {
	return `/api/v1/profile/phone/`
}

/**
 * Update phone number for the authenticated user.
 */
export const apiV1ProfilePhonePartialUpdate = async (
	patchedUserPhone?: NonReadonly<PatchedUserPhone>,
	options?: Parameters<typeof apiWithTokenAuth>[1],
): Promise<ApiV1ProfilePhonePartialUpdate200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {}
		if (h instanceof Headers) return Object.fromEntries(h.entries())
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			)
		}
		const headers: Record<string, string | readonly string[]> = {}
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value
		}
		return headers
	}
	return apiWithTokenAuth<ApiV1ProfilePhonePartialUpdate200>(
		getApiV1ProfilePhonePartialUpdateUrl(),
		{
			...options,
			method: "PATCH",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(patchedUserPhone),
		},
	)
}

export const getApiV1ProfilePhonePartialUpdateMutationKey = () =>
	["apiV1ProfilePhonePartialUpdate"] as const

export const getApiV1ProfilePhonePartialUpdateMutationOptions = <
	TError = ApiV1ProfilePhonePartialUpdate400,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
		TError,
		ApiV1ProfilePhonePartialUpdateMutationVariables,
		TContext
	>
	request?: SecondParameter<typeof apiWithTokenAuth>
}): UseMutationOptions<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
	TError,
	ApiV1ProfilePhonePartialUpdateMutationVariables,
	TContext
> => {
	const mutationKey = getApiV1ProfilePhonePartialUpdateMutationKey()
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined }

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
		ApiV1ProfilePhonePartialUpdateMutationVariables
	> = (props) => {
		const { data } = props ?? {}

		return apiV1ProfilePhonePartialUpdate(data, requestOptions)
	}

	return { mutationFn, ...mutationOptions }
}

export type ApiV1ProfilePhonePartialUpdateMutationResult = NonNullable<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>
>
export type ApiV1ProfilePhonePartialUpdateMutationBody =
	| NonReadonly<PatchedUserPhone>
	| undefined
export type ApiV1ProfilePhonePartialUpdateMutationError =
	ApiV1ProfilePhonePartialUpdate400
export type ApiV1ProfilePhonePartialUpdateMutationVariables = {
	data?: NonReadonly<PatchedUserPhone>
}

export const useApiV1ProfilePhonePartialUpdate = <
	TError = ApiV1ProfilePhonePartialUpdate400,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
			TError,
			ApiV1ProfilePhonePartialUpdateMutationVariables,
			TContext
		>
		request?: SecondParameter<typeof apiWithTokenAuth>
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof apiV1ProfilePhonePartialUpdate>>,
	TError,
	ApiV1ProfilePhonePartialUpdateMutationVariables,
	TContext
> => {
	return useMutation(
		getApiV1ProfilePhonePartialUpdateMutationOptions(options),
		queryClient,
	)
}
